import { SearchBar as MerchSearchBar } from '@carvana/merch-search-bar';
import { Dispatch, SetStateAction, useContext } from 'react';
import { useIsMobile } from '~/contexts/DeviceContext';
import ModalContext from '~/contexts/ModalContext';
import useSearchBarProps from '~/hooks/useSearchBarProps';

export default function SearchBar({
  inputValue,
  setInputValue
}: {
  inputValue: string;
  setInputValue: Dispatch<SetStateAction<string>>;
}) {
  const { setIsSearchBarFocused, setSearchBarModalOpen } =
    useContext(ModalContext);
  const {
    apiBaseUrl,
    cdnBaseUrl,
    geolocationState,
    onSuggestionSelection,
    refSource,
    savedSearches,
    trackEvent
  } = useSearchBarProps();
  const showModal = useIsMobile();

  return (
    <MerchSearchBar
      apiBaseUrl={apiBaseUrl}
      cdnBaseUrl={cdnBaseUrl}
      onSuggestionSelection={onSuggestionSelection}
      geolocationState={geolocationState}
      globalInputValue={inputValue}
      inputBgColor="gray"
      onFocus={setIsSearchBarFocused}
      onShowModalClick={newInputValue => {
        setInputValue(newInputValue);
        setSearchBarModalOpen(true);
      }}
      refSource={refSource}
      savedSearches={savedSearches}
      showButton={false}
      showModal={showModal}
      trackEvent={trackEvent}
    />
  );
}
